import { useState } from "react";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button.js";
import Image from "next/image.js";

// sections for this page
import ForumsTopicAddReply from "../ForumsTopicAddReply/ForumsTopicAddReply.js";

// local assets
import noPostsIcon from "../../public/img/forums/icons/noPostsIcon.png";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import {updateQueryString} from "../../util/url";
import {useRouter} from "next/router";
import {useAuthContext} from "../../contexts/auth";

const useStyles = makeStyles()(styles);

export default function ForumsNoReplies(props) {
    const { auth } = useAuthContext();
    const router = useRouter();
    const { topic } = props;
    const { classes, cx } = useStyles();

    const [textEditorOpen, setTextEditorOpen] = useState(false);

    const openTextEditor = async () => {
      if (auth.user == null) {
        await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
      } else {
        setTextEditorOpen(true);
      }
    };

    const closeTextEditor = () => {
      setTextEditorOpen(false);
    };

    return (
        <div className={classes.container}>
            {!textEditorOpen &&
                <div className={classes.noTopicsBox}>
                    <>
                        <Image className={classes.noTopicsIcon} src={noPostsIcon} alt={"no-replies-icon"} width={30} height={30}/>
                        <h2 className={classes.noTopicsTitle}>No Replies Yet</h2>
                        <p className={classes.noTopicsText}>It looks like no one has responded to this question yet. Be the first to share your knowledge and help a fellow community member!
                        </p>
                    </>
                    <Button onClick={openTextEditor} className={cx(classes.darkButton + " " + classes.newTopicButton)}>Reply</Button>
                </div>
            }
            <ForumsTopicAddReply topic={topic} open={textEditorOpen} onClose={closeTextEditor} type="reply" />
        </div>
    )
}
